import React, { Fragment, useState, useEffect } from 'react';


const Loader = () => {

    const [show, setShow] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShow(false);
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };

    }, [show]);

    return (
        <Fragment>
            <div className={`loader-wrapper ${show ? '' : 'loderhide'}`}>
                <div className="theme-loader">
                    <div className="loader-p"></div>
                </div>
            </div>
        </Fragment>
    );
};

const ContentLoader = ({ isLoading = true }) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        if( !isLoading ){
            setShow(false)
        }

    }, [isLoading]);

    return (
        <Fragment>
            <div className={`loader-content-wrapper ${show ? '' : 'loderhide'}`}>
                <div className="theme-loader">
                    <div className="loader-p"></div>
                </div>
            </div>
        </Fragment>
    );
};

const ProgressLoader = () => {
    return (
        <Fragment>
            <div className='loader-box' style={{height: "100px"}}>
                <div className="theme-loader">
                    <div className="loader-7"></div>
                </div>
            </div>
        </Fragment>
    );
};

export default Loader;
export {
    ProgressLoader,
    ContentLoader
}